import { ContentStates } from 'ContentComponents/constants/ContentStates';
import StateStatusGroups from 'ContentUtils/constants/StateStatusGroups';
export const getIsScheduled = state => StateStatusGroups.SCHEDULED.includes(state);
export const getIsPublished = state => StateStatusGroups.PUBLISHED.includes(state);
const abContentStates = [ContentStates.DRAFT_AB, ContentStates.PUBLISHED_AB, ContentStates.SCHEDULED_AB];
export const isAbContentState = state => {
  return abContentStates.includes(state);
};